import React, { Component } from 'react';
import App_data from '../../config/App_data';
import { browserHistory } from 'react-router';
import FD from '../../RestAPI/fetchData';
import GD from '../../RestAPI/getData';
import language from '../../../assets/languages/language';
// import { getDeviceDetails } from "../../../common/deviceDetails";
import { getIpAddress } from '../../../common/getIpAddress';
import AppRoutes from '../../config/AppRoutes';
/* eslint-disable */

class AppSumo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      message_background: 'bg-danger',
      displaytext: 'hide_block',
      username: '',
      email: '',
      password: '',
      repeatpassword: '',
      message: '',
      userNameErrorMessage: '',
      emailErrorMessage: '',
      passwordErrorMessage: '',
      repPasswordErrorMessage: '',
      code: '',
      codeErrorMessage: '',
      landingSource: 'AppSumo',
      landingSourceName: null,
      loading: false,
      userType: true,
      userIP: '',
      user_city: '',
      user_country: '',
      user_ip: '',
      user_state: '',
      user_continent: '',
    };
  }

  async componentDidMount() {
    GD.GetCallAPI('https://geolocation-db.com/json/').then((resp) => {
      this.setState({
        userIP: resp.IPv4,
      });
    });
    // api to get ip address
    const result1 = await getIpAddress();
    if (result1) {
      this.setState({
        user_city: result1.city,
        user_country: result1.country,
        user_ip: result1.query,
        user_state: result1.region,
        user_continent: result1.continent,
      });
    }
    //user tracking code

    // const result = getDeviceDetails();
    const data = {
      city: this.state.user_city,
      country: this.state.user_country,
      state: this.state.user_state,
      continent: this.state.user_continent,
      ip: this.state.user_ip,
    };
    localStorage.setItem('userData', JSON.stringify(data));
  }

  /*
  ----------------------
    Login form submit 
  ----------------------
  */
  onSubmitNewUser = (event) => {
    event.preventDefault();
    const userData = JSON.parse(localStorage.getItem('userData'));

    this.setState({
      displaytext: 'hide_block',
      message: '',
      loading: true,
    });
    if (this.state.username === '') {
      this.setState({
        displaytext: 'show_block',
        userNameErrorMessage: `${language.LC().User_Name_is_Required}`,
        loading: false,
      });
      return;
    }
    if (this.state.email === '') {
      this.setState({
        displaytext: 'show_block',
        emailErrorMessage: `${language.LC().Email_is_Required}`,
        loading: false,
      });
      return;
    }
    var emailValid = this.state.email.match(
      /^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i
    );
    if (emailValid) {
      if (this.state.password === '') {
        this.setState({
          displaytext: 'show_block',
          passwordErrorMessage: `${language.LC().Password_is_Required}`,
          loading: false,
        });
        return;
      }
      if (this.state.repeatpassword === '') {
        this.setState({
          displaytext: 'show_block',
          repPasswordErrorMessage: `${
            language.LC().Confirm_Password_is_Required
          }`,
          loading: false,
        });
        return;
      }
      if (this.state.password !== this.state.repeatpassword) {
        this.setState({
          displaytext: 'show_block',
          repPasswordErrorMessage: `${language.LC().Password_didnt_match}`,
          loading: false,
        });
        return;
      }
      if (this.state.password.length < 6) {
        this.setState({
          displaytext: 'show_block',
          passwordErrorMessage: `${
            language.LC().Please_enter_atleast_6_characters_in_the_field
          }`,
          loading: false,
        });
        return;
      }

      if (this.state.code === '') {
        this.setState({
          displaytext: 'show_block',
          codeErrorMessage: `${language.LC().Code_is_Required}`,
          loading: false,
        });
        return;
      }

      var data = {
        email: this.state.email,
        password: this.state.password,
        code: this.state.code,
        landingSource: this.state.landingSource,
        landingSourceName: this.state.landingSourceName,
        name: this.state.username,
        userIP: this.state.userIP,
        
      };

      FD.callAPI(App_data.backend_api + '/appSumo/signup', data).then(
        (resp) => {
          if (resp.success) {
            localStorage.setItem('loginID', resp.loginID);
            var localStorage_array = {
              token: resp.token,
              idname: this.state.email,
            };
            localStorage.setItem(
              'localstorageval',
              JSON.stringify(localStorage_array)
            );
            localStorage.setItem('selectedmenu', 'cfa');
            browserHistory.push({
              pathname: AppRoutes.DASHBOARD,
              state: { token: resp.token, idname: this.state.email },
            });
          } else {
            this.setState({
              displaytext: 'show_block',
              message: resp.message,
              loading: false,
            });
          }
        }
      );
    } else {
      this.setState({
        displaytext: 'show_block',
        loading: false,
        emailErrorMessage: `${language.LC().Email_Id_Invalid}`,
      });
      return;
    }
  };

  onSubmitOldUser = (event) => {
    event.preventDefault();
    const userData = JSON.parse(localStorage.getItem('userData'));
    console.log('***');
    this.setState({
      displaytext: 'hide_block',
      message: '',
      loading: true,
    });
    if (this.state.email === '') {
      this.setState({
        displaytext: 'show_block',
        emailErrorMessage: `${language.LC().Email_is_Required}`,
        loading: false,
      });
      return;
    }
    var emailValid = this.state.email.match(
      /^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i
    );
    if (emailValid) {
      if (this.state.password === '') {
        this.setState({
          displaytext: 'show_block',
          passwordErrorMessage: `${language.LC().Password_is_Required}`,
          loading: false,
        });
        return;
      }
      this.setState({
        displaytext: 'hide_block',
        message: '',
        emailErrorMessage: '',
        passwordErrorMessage: '',
        loading: false,
      });

      if (this.state.code === '') {
        this.setState({
          displaytext: 'show_block',
          codeErrorMessage: `${language.LC().Code_is_Required}`,
          loading: false,
        });
        return;
      }

      var data = {
        email: this.state.email,
        password: this.state.password,
        code: this.state.code,
        userIP: this.state.userIP,
      };
      FD.callAPI(App_data.backend_api + '/appSumo/login', data).then((resp) => {
        if (resp.success) {
          localStorage.setItem('loginID', resp.loginID);
          var localStorage_array = {
            token: resp.token,
            idname: this.state.email,
          };
          localStorage.setItem(
            'localstorageval',
            JSON.stringify(localStorage_array)
          );
          localStorage.setItem('selectedmenu', 'cfa');
          browserHistory.push({
            pathname: AppRoutes.DASHBOARD,
            state: { token: resp.token, idname: this.state.email },
          });
        } else {
          this.setState({
            displaytext: 'show_block',
            message: resp.message,
            password: '',
            loading: false,
          });
        }
      });
    } else {
      this.setState({
        displaytext: 'show_block',
        emailErrorMessage: `${language.LC().Email_Id_Invalid}`,
        loading: false,
      });
      return;
    }
  };
  updateEmail = (e) => {
    console.log('');
    var email_lower = e.target.value.toLowerCase();
    this.setState({
      message: '',
      email: email_lower,
      emailErrorMessage: '',
    });
  };
  updatePassword = (e) => {
    this.setState({
      message: '',
      password: e.target.value,
      passwordErrorMessage: '',
    });
  };
  updateRepeatPassword = (e) => {
    this.setState({
      message: '',
      repeatpassword: e.target.value,
      repPasswordErrorMessage: '',
    });
  };

  updateCode = (e) => {
    this.setState({ message: '', code: e.target.value, codeErrorMessage: '' });
  };

  updateUserName = (e) => {
    this.setState({
      message: '',
      username: e.target.value,
      userNameErrorMessage: '',
    });
  };

  handleChange = (e) => {
    console.log(':dfdddd');
    this.setState({
      userType: !this.state.userType,
      displaytext: 'hide_block',
      message: '',
    });
  };

  render() {
    console.log('ddddd', this.state.userType);
    return (
      <div className='container'>
        {/* <div className="row"> */}
        <div className='text-center margin_bottom_20 logo_wrapper appSumo_Logo'>
          <img
            src={App_data.frontend_url + '/img/logo1.png'}
            alt=''
            width='121px'
            className='mr-1'
          />{' '}
          <strong>X</strong>
          {/* <img
            src={App_data.frontend_url + "/img/cancel.svg"}
            alt=""
            width="24px" */}
          {/* />{" "} */}
          <img
            src={App_data.frontend_url + '/img/as-appsumo-logo-footer.svg'}
            alt=''
            width='121px'
            className='ml-1'
          />{' '}
        </div>
        {/* </div> */}
        <div className='row justify-content-center'>
          <div className='col-xs-12 col-sm-12 col-md-6 col-lg-4'>
            <div className='card-group mb-0'>
              <div className='card p-2  '>
                <div className='card-block'>
                  {/* <h4>AppSumo</h4> */}

                  {this.state.userType ? (
                    <p className='text-muted'>Fill this information:</p>
                  ) : null}
                  {this.state.userType ? (
                    <form
                      className='sign-up-form-wrap'
                      onSubmit={this.onSubmitNewUser}
                    >
                      {' '}
                      <p className={this.state.displaytext + ' text-danger'}>
                        {this.state.message}
                      </p>
                      <div className='form-group'>
                        <div className='d-flex'>
                          <span className='input-group-addon-social-registration'>
                            <img
                              src={
                                App_data.frontend_url +
                                '/img/profile/user_ico.svg'
                              }
                              className=''
                              alt=''
                              width='15'
                            />
                          </span>
                          <input
                            type='text'
                            className='form-control'
                            placeholder={language.LC().USERNAME}
                            value={this.state.username}
                            onChange={this.updateUserName}
                          />
                        </div>
                        <p className={this.state.displaytext + ' text-danger'}>
                          {this.state.userNameErrorMessage}
                        </p>
                      </div>
                      <div className='form-group'>
                        <div className='d-flex'>
                          <span className='input-group-addon-social-registration'>
                            <img
                              src={
                                App_data.frontend_url +
                                '/img/profile/mail_ico.svg'
                              }
                              className=''
                              alt=''
                              width='15'
                            />
                          </span>
                          <input
                            type='email'
                            className='form-control'
                            placeholder={language.LC().EMAIL}
                            value={this.state.email}
                            onChange={this.updateEmail}
                          />
                        </div>{' '}
                        <p className={this.state.displaytext + ' text-danger'}>
                          {this.state.emailErrorMessage}
                        </p>
                      </div>
                      <div className='form-group'>
                        <div className='d-flex'>
                          <span className='input-group-addon-social-registration'>
                            <img
                              src={App_data.frontend_url + '/img/pin-code.svg'}
                              className=''
                              alt=''
                              width='15'
                            />
                          </span>

                          <input
                            type='password'
                            className='form-control'
                            placeholder={language.LC().PASSWORD}
                            value={this.state.password}
                            onChange={this.updatePassword}
                          />
                        </div>
                        <p className={this.state.displaytext + ' text-danger'}>
                          {this.state.passwordErrorMessage}
                        </p>
                      </div>
                      <div className='form-group'>
                        <div className='d-flex'>
                          <span className='input-group-addon-social-registration'>
                            <img
                              src={App_data.frontend_url + '/img/pin-code.svg'}
                              className=''
                              alt=''
                              width='15'
                            />
                          </span>

                          <input
                            type='password'
                            className='form-control'
                            placeholder={language.LC().CONFIRM_PASSWORD}
                            value={this.state.repeatpassword}
                            onChange={this.updateRepeatPassword}
                          />
                        </div>
                        <p className={this.state.displaytext + ' text-danger'}>
                          {this.state.repPasswordErrorMessage}
                        </p>
                      </div>
                      <div className='form-group'>
                        <div className='d-flex'>
                          <span className='input-group-addon-social-registration'>
                            <img
                              src={
                                App_data.frontend_url +
                                '/img/safari-pinned-tab.svg'
                              }
                              className=''
                              alt=''
                              width='15'
                            />
                          </span>

                          <input
                            type='text'
                            className='form-control'
                            placeholder={language.LC().APPSUMO_CODE}
                            maxLength='7'
                            value={this.state.code}
                            onChange={this.updateCode}
                          />
                        </div>
                        <p className={this.state.displaytext + ' text-danger'}>
                          {this.state.codeErrorMessage}
                        </p>
                      </div>
                      <div className='row'>
                        <div className='col-md-12'>
                          <button
                            type='submit'
                            style={{ width: 100 + '%' }}
                            className='btn btn-primary'
                          >
                            {this.state.loading
                              ? 'Please wait...'
                              : language.LC().SIGN_UP}
                          </button>
                          <div
                            className='AppSumoFooter'
                            onClick={() => this.handleChange()}
                          >
                            {' '}
                            {language.LC().EXISTING_USER_APP_SUMO}
                          </div>
                        </div>
                      </div>
                    </form>
                  ) : (
                    <form
                      className='sign-up-form-wrap'
                      onSubmit={this.onSubmitOldUser}
                    >
                      {' '}
                      <p className={this.state.displaytext + ' text-danger'}>
                        {this.state.message}
                      </p>
                      <div className='form-group'>
                        <div className='d-flex'>
                          <span className='input-group-addon-social-registration'>
                            <img
                              src={
                                App_data.frontend_url +
                                '/img/profile/mail_ico.svg'
                              }
                              className=''
                              alt=''
                              width='15'
                            />
                          </span>
                          <input
                            type='email'
                            className='form-control'
                            placeholder={language.LC().EMAIL}
                            value={this.state.email}
                            onChange={this.updateEmail}
                          />
                        </div>{' '}
                        <p className={this.state.displaytext + ' text-danger'}>
                          {this.state.emailErrorMessage}
                        </p>
                      </div>
                      <div className='form-group'>
                        <div className='d-flex'>
                          <span className='input-group-addon-social-registration'>
                            <img
                              src={App_data.frontend_url + '/img/pin-code.svg'}
                              className=''
                              alt=''
                              width='15'
                            />
                          </span>

                          <input
                            type='password'
                            className='form-control'
                            placeholder={language.LC().PASSWORD}
                            value={this.state.password}
                            onChange={this.updatePassword}
                          />
                        </div>
                        <p className={this.state.displaytext + ' text-danger'}>
                          {this.state.passwordErrorMessage}
                        </p>
                      </div>
                      <div className='form-group'>
                        <div className='d-flex'>
                          <span className='input-group-addon-social-registration'>
                            <img
                              src={
                                App_data.frontend_url +
                                '/img/safari-pinned-tab.svg'
                              }
                              className=''
                              alt=''
                              width='15'
                            />
                          </span>

                          <input
                            type='text'
                            className='form-control'
                            placeholder={language.LC().APPSUMO_CODE}
                            maxLength='7'
                            value={this.state.code}
                            onChange={this.updateCode}
                          />
                        </div>
                        <p className={this.state.displaytext + ' text-danger'}>
                          {this.state.codeErrorMessage}
                        </p>
                      </div>
                      <div className='row'>
                        <div className='col-md-12'>
                          <button
                            type='submit'
                            style={{ width: 100 + '%' }}
                            className='btn btn-primary'
                          >
                            {this.state.loading
                              ? 'Please wait...'
                              : language.LC().SIGN_IN}
                          </button>
                          <div
                            className='AppSumoFooter'
                            onClick={() => this.handleChange()}
                          >
                            {' '}
                            {language.LC().NEW_USER_APP_SUMO}
                          </div>
                        </div>
                      </div>
                    </form>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default AppSumo;



// WEBPACK FOOTER //
// ./src/views/Pages/AppSumo/AppSumo.js